<template>
  <div class="card noborder">
    <div class="card-body pb-0">
      <h5 class="mb-0">Apex Equipment Details</h5>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label class="custom-label">What kind of Headunit/s</label>
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width: 150px;">New</span>
              </div>
              <input class="form-control" placeholder="0" style="max-width: 80px;"
                :value="apex.headunitsNew"
                @input="$store.commit('changeApexHeadunitsNew', $event.target.value)"
              >
              <div class="input-group-append">
                <span class="input-group-text">Units</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width: 150px;">Refurbished</span>
              </div>
              <input class="form-control" placeholder="0" style="max-width: 80px;"
                :value="apex.headunitsRefurbished"
                @input="$store.commit('changeApexHeadunitsRefurbished', $event.target.value)"
              >
              <div class="input-group-append">
                <span class="input-group-text">Units</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="small-printers-apex">
        <div class="form-group">
          <label class="custom-label">What kind of 4' Printer/s</label>
          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="small-printers-apex1"
                  @change="$store.commit('changeSmallPrinters', { key: 'apex', value:'new' })"
                  :checked="apex.smallPrinters.includes('new')"
                >
                <label class="form-check-label" for="small-printers-apex1">New</label>
              </div>
              <div v-if="apex.smallPrinters.includes('new')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(apex.smallPrintersNew)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="apex.smallPrintersNew[printer]"
                  @input="$store.commit('changeSmallPrintersNew', { key:'apex', printer, value: $event })"
                />

              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="small-printers-apex2"
                  @change="$store.commit('changeSmallPrinters', { key: 'apex', value:'refurbished' })"
                  :checked="apex.smallPrinters.includes('refurbished')"
                >
                <label class="form-check-label" for="small-printers-apex2">Refurbished</label>
              </div>
              <div v-if="apex.smallPrinters.includes('refurbished')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(apex.smallPrintersRefurbished)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="apex.smallPrintersRefurbished[printer]"
                  @input="$store.commit('changeSmallPrintersRefurbished', { key:'apex', printer, value: $event })"
                />

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="large-printers-apex">
        <div class="form-group">
          <label class="custom-label">What kind of 8' Printer/s</label>
          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="large-printers-apex1"
                  @change="$store.commit('changeLargePrinters', { key: 'apex', value:'new' })"
                  :checked="apex.largePrinters.includes('new')"
                >
                <label class="form-check-label" for="large-printers-apex1">New</label>
              </div>
              <div v-if="apex.largePrinters.includes('new')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(apex.largePrintersNew)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="apex.largePrintersNew[printer]"
                  @input="$store.commit('changeLargePrintersNew', { key:'apex', printer, value: $event })"
                />

              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="large-printers-apex2"
                  @change="$store.commit('changeLargePrinters', { key: 'apex', value:'refurbished' })"
                  :checked="apex.largePrinters.includes('refurbished')"
                >
                <label class="form-check-label" for="large-printers-apex2">Refurbished</label>
              </div>
              <div v-if="apex.largePrinters.includes('refurbished')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(apex.largePrintersRefurbished)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="apex.largePrintersRefurbished[printer]"
                  @input="$store.commit('changeLargePrintersRefurbished', { key:'apex', printer, value: $event })"
                />

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cabinet">
        <div class="form-group">
          <label class="custom-label">What kind of Cabinet/s</label>
          <br>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 150px;">APEX 30'</span>
            </div>
            <input class="form-control" placeholder="0" style="max-width: 80px;"
              :value="apex.cabinets['APEX 30']"
              @input="$store.commit('changeApexCabinets', { cabinet: 'APEX 30', value: $event.target.value })"
            >
            <div class="input-group-append">
              <span class="input-group-text">Cabinets</span>
            </div>
          </div>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 150px;">APEX 40'</span>
            </div>
            <input class="form-control" placeholder="0" style="max-width: 80px;"
              :value="apex.cabinets['APEX 40']"
              @input="$store.commit('changeApexCabinets', { cabinet: 'APEX 40', value: $event.target.value })"
            >
            <div class="input-group-append">
              <span class="input-group-text">Cabinets</span>
            </div>
          </div>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width: 150px;">APEX 70'</span>
            </div>
            <input class="form-control" placeholder="0" style="max-width: 80px;"
              :value="apex.cabinets['APEX 70']"
              @input="$store.commit('changeApexCabinets', { cabinet: 'APEX 70', value: $event.target.value })"
            >
            <div class="input-group-append">
              <span class="input-group-text">Cabinets</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['apex'],
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/ApexForm.vue